module.exports = __webpack_public_path__ + "static/media/mp.f47c0947.svg";